import { useAudienceJoinCountStore } from '@mentimeter/audience-join-count';
import { useQuestionResults, useQuestion } from '../../../data-mediation';
import { getCategory } from '../../../utils/category';
import { RespondentsIndicator } from './RespondentsIndicator';

export const RespondentsIndicatorDataHandler = () => {
  const { respondents = 0 } = useQuestionResults() ?? {};
  const audienceMemberCount = useAudienceJoinCountStore((state) => state.count);

  const { type } = useQuestion();
  const category = getCategory(type);

  if (category === 'quiz') {
    return null;
  }

  if (category === 'interactive') {
    return (
      <RespondentsIndicator
        respondentCount={respondents}
        audienceMemberCount={audienceMemberCount}
      />
    );
  }

  // qfa and content slides
  return (
    <RespondentsIndicator
      respondentCount={undefined}
      audienceMemberCount={audienceMemberCount}
    />
  );
};
